import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const UpdateOffer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { authFetch, user } = useContext(AuthContext); // <-- Obtener token + usuario

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [areas, setAreas] = useState([]);


  // ===============================
  //   CARGAR DATOS DE LA OFERTA
  // ===============================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await authFetch(ENDPOINTS.getOfertaById(id));
        setFormData(res);
        setLoading(false);
      } catch (err) {
        console.error("Error al cargar oferta:", err);
        setError("No se pudo cargar la información");
        setLoading(false);
      }
    };

    fetchData();
  }, [id, authFetch]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ===============================
  //   ACTUALIZAR OFERTA
  // ===============================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // ------------------------------
    // Validación mínima
    // ------------------------------
    const requiredFields = [
      "professional_program",
      "area",
      "functions",
      "type_contract",
      "duration",
      "place",
      "minimum_education",
      "experience",
    ];

    const empty = requiredFields.filter(
      (field) =>
        !formData[field] ||
        formData[field].toString().trim() === ""
    );

    if (empty.length > 0) {
      setError("Debes completar todos los campos obligatorios.");
      return;
    }

    try {
      const payload = {
        ...formData,
        update_by: user?.IdDocumento || null,
      };

      const res = await authFetch(ENDPOINTS.updateOfferById(id), {
        method: "POST",
        body: JSON.stringify(payload),
      });

      if (!res.success) {
        setError(res.message || "Error al actualizar la oferta");
        return;
      }

      setSuccess("Oferta actualizada correctamente ✔");

      setTimeout(() => {
        navigate("/session/offer/offers");
      }, 1500);

    } catch (err) {
      console.error("Error al actualizar:", err);
      setError("Error en el servidor");
    }
  };

  useEffect(() => {
  const fetchAreas = async () => {
    try {
      const res = await authFetch(ENDPOINTS.getarea, {
        method: "GET"
      });

      if (res.success) {
        setAreas(res.data);
      }

    } catch (err) {
      console.error("Error cargando áreas:", err);
    }
  };

  fetchAreas();
}, [authFetch]);


  if (loading) {
    return <div className="text-center mt-5">Cargando información...</div>;
  }

  return (
    <div className="p-4">
      {/* TÍTULO Y VOLVER */}
      <div className="d-flex justify-content-between align-items-center m-3">
        <h3>Modificar -  {formData.professional_program}</h3>
        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/offer/offers")}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>
      </div>

      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {/* ALERTAS */}
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* === FILA 1 === */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Programa profesional *</label>
            <input
              type="text"
              name="professional_program"
              className="form-control"
              value={formData.professional_program || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Área *</label>
            <select
                name="area"
                className="form-select"
                value={formData.area || ""}
                onChange={handleChange}
              >
                <option value=""hidden>Selecciona...</option>

                {areas.map((area) => (
                  <option key={area.id_area} value={area.id_area}>
                    {area.name}
                  </option>
                ))}
              </select>

          </div>
        </div>

        {/* === FILA 2 === */}
        <div className="row">
            <div className="col-md-6 mb-3">
                <label>Tipo de contrato *</label>
                <select
                name="type_contract"
                className="form-select"
                value={formData.type_contract || ""}
                onChange={handleChange}
                >
                <option value="" hidden>Seleccione...</option>
                <option value="Prestación de servicios">Prestación de servicios</option>
                <option value="Obra labor">Obra labor</option>
                <option value="Indefinido">Indefinido</option>
                <option value="Fijo">Fijo</option>
                </select>
            </div>

          <div className="col-md-6 mb-3">
            <label>Duración *</label>
            <input
              type="text"
              name="duration"
              className="form-control"
              value={formData.duration || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* === FILA 3 === */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Salario *</label>
            <small style={{ fontSize: "12px", color: "gray" }}>
             Ingrese el valor sin puntos ni comas.
            </small>
            <input
              type="number"
              name="salary"
              className="form-control"
              value={formData.salary || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Lugar de ejecución *</label>
            <input
              type="text"
              name="place"
              className="form-control"
              value={formData.place || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* === FILA 4 === */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Educación mínima *</label>
            <input
              type="text"
              name="minimum_education"
              className="form-control"
              value={formData.minimum_education || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Experiencia *</label>
            <input
              type="text"
              name="experience"
              className="form-control"
              value={formData.experience || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* === FUNCTIONS SOLO === */}
        <div className="mb-3">
          <label>Descripción del cargo *</label>
          <textarea
            name="functions"
            className="form-control"
            rows="3"
            value={formData.functions || ""}
            onChange={handleChange}
          ></textarea>
        </div>

        {/* === FILA 5 === CHECK RADIOS === */}
        <div className="row">

        {/* Manipulación de alimentos */}
        <div className="col-md-4 mb-3">
            <label className="form-label">Manipulación de alimentos *</label>

            <div className="d-flex gap-3">

            <div className="form-check form-check-inline">
                <input
                type="radio"
                className="form-check-input"
                name="curso_manipulacion_alimento"
                value="Si"
                checked={formData.curso_manipulacion_alimento === "Si"}
                onChange={handleChange}
                />
                <label className="form-check-label">Sí</label>
            </div>

            <div className="form-check form-check-inline">
                <input
                type="radio"
                className="form-check-input"
                name="curso_manipulacion_alimento"
                value="No"
                checked={formData.curso_manipulacion_alimento === "No"}
                onChange={handleChange}
                />
                <label className="form-check-label">No</label>
            </div>

            </div>
        </div>

        {/* Curso de alturas */}
        <div className="col-md-4 mb-3">
            <label className="form-label">Curso de alturas *</label>

            <div className="d-flex gap-3">

            <div className="form-check form-check-inline">
                <input
                type="radio"
                className="form-check-input"
                name="curso_altura"
                value="Si"
                checked={formData.curso_altura === "Si"}
                onChange={handleChange}
                />
                <label className="form-check-label">Sí</label>
            </div>

            <div className="form-check form-check-inline">
                <input
                type="radio"
                className="form-check-input"
                name="curso_altura"
                value="No"
                checked={formData.curso_altura === "No"}
                onChange={handleChange}
                />
                <label className="form-check-label">No</label>
            </div>

            </div>
        </div>

        {/* Tarjeta profesional */}
        <div className="col-md-4 mb-3">
            <label className="form-label">Tarjeta profesional *</label>

            <div className="d-flex gap-3">

            <div className="form-check form-check-inline">
                <input
                type="radio"
                className="form-check-input"
                name="professional_card"
                value="Si"
                checked={formData.professional_card === "Si"}
                onChange={handleChange}
                />
                <label className="form-check-label">Sí</label>
            </div>

            <div className="form-check form-check-inline">
                <input
                type="radio"
                className="form-check-input"
                name="professional_card"
                value="No"
                checked={formData.professional_card === "No"}
                onChange={handleChange}
                />
                <label className="form-check-label">No</label>
            </div>

            </div>
        </div>

        </div>



        {/* === BOTÓN GUARDAR === */}
        <div className="text-end mt-4">
          <button type="submit" className="btn btn-outline-pink">
            Guardar cambios
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateOffer;
